import { type JSX } from 'react';
import { useLocale } from '@repo/i18n';
import Button from 'src/components/common/timeslots-buttons/button/Button';
import { useNativeMemberContext } from './NativeMemberContext';

// Opens the auth modal on the sign-up tab. Renders nothing unless the tenant runs native
// membership, and disappears once the visitor is logged in (a "become a member" CTA has no
// purpose then) — unlike MemberLoginButton, which becomes a logout button.
export default function MemberSignupButton(): JSX.Element | null {
    const { t } = useLocale();
    const { isNative, isLoggedIn, openAuthModal } = useNativeMemberContext();

    if (!isNative || isLoggedIn) return null;

    return <Button text={t.become_member} onClick={() => openAuthModal('signup')} />;
}
